import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase-config";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import TranscribePage from "./pages/TranscribePage";
import AppointmentsPage from "./pages/AppointmentsPage";
import QuizPage from "./pages/QuizPage";
import AuthPage from "./pages/AuthPage";
import UserProfile from "./pages/UserProfile";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import "./App.css";

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setAuthReady(true);
    });
    return () => unsub();
  }, []);

  if (!authReady) {
    return <div style={{ padding: "2rem" }}>Loading...</div>;
  }

  return (
    <Router>
      {currentUser && <Navbar />}
      <div className="app-container">
        <Routes>
          <Route
            path="/auth"
            element={currentUser ? <Navigate to="/transcribe" replace /> : <AuthPage />}
          />
          <Route
            path="/"
            element={currentUser ? <Home /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/transcribe"
            element={currentUser ? <TranscribePage /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/appointments"
            element={currentUser ? <AppointmentsPage /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/quiz"
            element={currentUser ? <QuizPage /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/profile"
            element={currentUser ? <UserProfile /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/billing/success"
            element={currentUser ? <BillingSuccess /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/billing/cancel"
            element={currentUser ? <BillingCancel /> : <Navigate to="/auth" replace />}
          />
          <Route path="*" element={<Navigate to={currentUser ? "/transcribe" : "/auth"} replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
